<template>
    <div class="draw-container">
        <!-- 全屏时的关闭按钮 -->
        <el-tooltip class="item" effect="dark" placement="top" content="退出全屏">
            <i class="el-icon-circle-close close-fullscreen-btn" v-show="fullscreen" @click="exitFullscreen"></i>
        </el-tooltip>

        <div class="operate-group">
            <!-- 画笔颜色 - 自定义图标风格 -->
            <el-tooltip class="item" effect="dark" placement="top" content="画笔颜色">
                <div class="color-picker-icon" @click="triggerColorPicker">
                    <svg viewBox="0 0 1024 1024" width="18" height="18" fill="currentColor" class="color-picker-svg">
                        <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z" />
                        <path d="M512 632c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120z m0-200c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z"  />
                        <circle cx="512" cy="512" r="180" :fill="color"/>
                    </svg>
                    <input ref="colorInput" type="color" v-model="color" @change="onColorChange" class="hidden-color-input" />
                </div>
            </el-tooltip>

            <!-- 撤销/重做/清除/全屏 -->
            <el-tooltip class="item" effect="dark" placement="top" content="撤销">
                <svg viewBox="0 0 1024 1024" class="undo" :class="{ isUndoAble }" @click="canvasUndo">
                    <path d="M512 64A510.272 510.272 0 0 0 149.984 213.984L0.032 64v384h384L240.512 304.48A382.784 382.784 0 0 1 512.032 192c212.064 0 384 171.936 384 384 0 114.688-50.304 217.632-130.016 288l84.672 96a510.72 510.72 0 0 0 173.344-384c0-282.784-229.216-512-512-512z"></path>
                </svg>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" placement="top" content="重做">
                <svg viewBox="0 0 1024 1024" class="redo" :class="{ isRedoAble }" @click="canvasRedo">
                    <path d="M0.00032 576a510.72 510.72 0 0 0 173.344 384l84.672-96A383.136 383.136 0 0 1 128.00032 576C128.00032 363.936 299.93632 192 512.00032 192c106.048 0 202.048 42.976 271.52 112.48L640.00032 448h384V64l-149.984 149.984A510.272 510.272 0 0 0 512.00032 64C229.21632 64 0.00032 293.216 0.00032 576z"></path>
                </svg>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" placement="top" :content="fullscreen ? '全屏' : '全屏'">
                <svg viewBox="0 0 1024 1024" @click="handleFull" :style="{ color: fullscreen ? '#000000' : '#00E5FF'}" fill="currentColor">
                    <path d="M133.705143 335.433143V133.851429h201.581714a29.622857 29.622857 0 0 0 29.622857-29.549715V68.754286a29.622857 29.622857 0 0 0-29.622857-29.622857H61.732571A22.893714 22.893714 0 0 0 38.765714 62.025143V335.725714c0 16.310857 13.238857 29.622857 29.622857 29.622857h35.547429a29.842286 29.842286 0 0 0 29.696-29.842285zM690.980571 133.851429h201.581715v201.654857c0 16.310857 13.238857 29.549714 29.622857 29.549714h35.547428a29.622857 29.622857 0 0 0 29.549715-29.549714V61.952a22.893714 22.893714 0 0 0-22.820572-22.893714h-273.554285a29.622857 29.622857 0 0 0-29.549715 29.622857v35.547428c0 16.310857 13.238857 29.696 29.622857 29.696zM335.286857 892.781714H133.705145V691.2a29.622857 29.622857 0 0 0-29.622857-29.622857H68.534857a29.622857 29.622857 0 0 0-29.549714 29.622857v273.554286c0 12.653714 10.24 22.893714 22.820571 22.893714h273.554286a29.622857 29.622857 0 0 0 29.696-29.622857v-35.547429a29.769143 29.769143 0 0 0-29.769143-29.696z m557.348572-201.581714v201.581714H690.907429a29.622857 29.622857 0 0 0-29.622858 29.622857v35.547429c0 16.310857 13.238857 29.622857 29.622858 29.622857h273.554285c12.580571 0 22.893714-10.313143 22.893715-22.893714V691.2a29.622857 29.622857 0 0 0-29.622858-29.622857h-35.547428a29.622857 29.622857 0 0 0-29.696 29.622857z"></path>
                </svg>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" placement="top" content="清除">
                <svg viewBox="0 0 1024 1024" class="clear" @click="canvasClear" :style="{ color: hasContent ? '#00E5FF' : '#000000' }" fill="currentColor">
                    <path d="M969.382408 288.738615l-319.401123-270.852152a67.074236 67.074236 0 0 0-96.459139 5.74922l-505.931379 574.922021a68.35184 68.35184 0 0 0-17.886463 47.910169 74.101061 74.101061 0 0 0 24.274486 47.910168l156.50655 132.232065h373.060512L975.131628 383.281347a67.074236 67.074236 0 0 0-5.74922-96.459139z m-440.134747 433.746725H264.144729l-90.071117-78.572676c-5.74922-5.74922-12.137243-12.137243-12.137243-17.886463a36.411728 36.411728 0 0 1 5.749221-24.274485l210.804741-240.828447 265.102932 228.691204z m-439.495945 180.781036h843.218964a60.047411 60.047411 0 1 1 0 120.733624H89.751716a60.047411 60.047411 0 1 1 0-120.733624z m0 0"></path>
                </svg>
            </el-tooltip>

            <!-- 画笔工具 -->
            <el-tooltip class="item" effect="dark" placement="top" content="画笔工具">
                <el-button type="text" :class="{ 'tool-active': activeTool === 'draw', 'active-tool-text': activeTool === 'draw' }" @click="activateDrawTool">
                    <i class="el-icon-brush"></i> 画笔
                </el-button>
            </el-tooltip>

            <!-- 画笔类型 -->
            <el-tooltip class="item" effect="dark" placement="top" content="画笔类型">
                <el-select 
                    v-model="brushType" 
                    size="mini" 
                    style="width: 110px;" 
                    :disabled="activeTool === 'text' || activeTool === 'move'"
                    :class="{ 'brush-select-active': activeTool === 'draw' }"
                    popper-class="brush-select-popper">
                    <el-option label="自由画笔" value="free"></el-option>
                    <el-option label="直线" value="line"></el-option>
                    <el-option label="带箭头直线" value="arrow"></el-option>
                    <el-option label="虚线" value="dashed"></el-option>
                    <el-option label="矩形" value="rectangle"></el-option>
                    <el-option label="三角形" value="triangle"></el-option>
                    <el-option label="平行四边形" value="parallelogram"></el-option>
                    <el-option label="圆" value="circle"></el-option>
                    <el-option label="椭圆" value="ellipse"></el-option>
                </el-select>
            </el-tooltip>

            <!-- 移动工具 -->
            <el-tooltip class="item" effect="dark" placement="top" content="移动工具">
                <el-button type="text" :class="{ 'tool-active': activeTool === 'move', 'active-tool-text': activeTool === 'move'}" @click="activateMoveTool">
                    <i class="el-icon-rank"></i> 移动
                </el-button>
            </el-tooltip>

            <!-- 文字工具 -->
            <el-tooltip class="item" effect="dark" placement="top" content="文字工具">
                <el-button type="text" :class="{ 'tool-active': activeTool === 'text', 'active-tool-text': activeTool === 'text'}" @click="activateTextTool">
                    <i class="el-icon-edit"></i> 文字
                </el-button>
            </el-tooltip>

            <!-- 函数图像下拉菜单 -->
            <el-dropdown trigger="click" @command="drawFunctionByCommand">
                <el-button type="text" class="function-btn">
                    <i class="el-icon-data-line"></i> 函数图像
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="linear">一元一次函数 y = 2x + 1</el-dropdown-item>
                    <el-dropdown-item command="quadratic">一元二次函数 y = x² - 2</el-dropdown-item>
                    <el-dropdown-item command="cubic">一元三次函数 y = x³/3 - x</el-dropdown-item>
                    <el-dropdown-item command="reciprocal">反比例函数 y = 3/x</el-dropdown-item>
                    <el-dropdown-item command="exp">指数函数 y = 2^x</el-dropdown-item>
                    <el-dropdown-item command="log">对数函数 y = ln(x+1)</el-dropdown-item>
                    <el-dropdown-item command="hook">对勾函数 y = x + 1/x</el-dropdown-item>
                    <el-dropdown-item command="sin">正弦函数 y = sin(x)</el-dropdown-item>
                    <el-dropdown-item command="cos">余弦函数 y = cos(x)</el-dropdown-item>
                    <el-dropdown-item command="tan">正切函数 y = tan(x)</el-dropdown-item>
                    <el-dropdown-item command="sinc">sinc函数 y = sin(x)/x</el-dropdown-item>
                    <el-dropdown-item command="lnxdivx">y = ln(x)/x</el-dropdown-item>
                    <el-dropdown-item command="xsinx">y = x·sin(x)</el-dropdown-item>
                    <el-dropdown-item command="expdivx">y = e^x / x</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <!-- 移动端优化的画笔粗细控件 -->
            <div class="thickness-control" @touchstart.stop @touchmove.stop>
                <span class="thickness-label">粗细</span>
                <input type="range"
                       min="1"
                       max="20"
                       v-model="size"
                       @input="handleSizeInput"
                       @change="handleSizeChange"
                       class="thickness-slider">
                <span class="thickness-value">{{ size }}</span>
            </div>
        </div>

        <canvas ref="mainCanvas"
            @mousedown="onCanvasMouseDown"
            @mousemove="onCanvasMouseMove"
            @mouseup="onCanvasMouseUp"
            @mouseleave="onCanvasMouseLeave"
            @touchstart.prevent="onCanvasTouchStart"
            @touchmove.prevent="onCanvasTouchMove"
            @touchend.prevent="onCanvasTouchEnd"
            @dblclick="onCanvasDoubleClick"
            @contextmenu.prevent>
        </canvas>

        <!-- 文字编辑弹窗 -->
        <el-dialog class="draw-dialog" :title="textDialogTitle" :visible.sync="textDialogVisible" width="400px" append-to-body>
            <el-input v-model="textInputContent" placeholder="请输入文字" maxlength="100" show-word-limit autofocus></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="textDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveTextContent">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'DrawPad',
    props: {
        fullscreen: { type: Boolean, default: false },
        storageKey: { type: String, default: 'drawpad_state' }
    },
    data() {
        return {
            mainCanvas: null,
            mainCtx: null,
            offCanvas: null,
            offCtx: null,
            dpr: window.devicePixelRatio || 1,
            timer: null,

            isDrawing: false,
            startPoint: null,
            lastPos: null,

            brushType: 'free',
            size: 1,
            color: '#FF0000',

            history: [],
            step: -1,

            texts: [],
            shapes: [],
            selectedShapeId: null,
            activeTool: 'draw',
            selectedTextId: null,   // 新增，用于文字选中

            draggingTextId: null,
            dragStartX: 0,
            dragStartY: 0,
            draggingShapeId: null,
            dragShapeOffsetX: 0,
            dragShapeOffsetY: 0,

            textDialogVisible: false,
            textDialogTitle: '添加文字',
            textInputContent: '',
            pendingTextPosition: null,
            editingTextId: null,

            isUndoAble: false,
            isRedoAble: false,
            resizeObserver: null,

            xMin: -6,
            xMax: 6,
            yMin: -5,
            yMax: 5,
            
            hasContent: false,

            // 自由画笔矢量数据
            freeDrawPaths: [],        // 存储已完成的笔划 { points: [{x,y}], color, lineWidth }
            currentFreePath: null,    // 当前正在绘制的笔划
            // 函数图像存储为数组，支持多曲线
            functions: [],            // 每个元素 { command, func, color, lineWidth }
            gridEnabled: true,        // 是否显示网格和坐标轴
        };
    },
    mounted() {
        this.mainCanvas = this.$refs.mainCanvas;
        this.mainCtx = this.mainCanvas.getContext('2d');
        this.offCanvas = document.createElement('canvas');
        this.offCtx = this.offCanvas.getContext('2d');
        this.initCanvas().then(() => {
            this.loadFromLocalStorage();
            this.rebuildBackground();
            this.saveHistoryState();
            this.updateHasContent();
        });
        this.resizeObserver = new ResizeObserver(() => {
            this.onCanvasResize();
        });
        this.resizeObserver.observe(this.mainCanvas);
        window.addEventListener('beforeunload', this.saveToLocalStorage);
    },
    beforeDestroy() {
        this.resizeObserver?.disconnect();
        clearTimeout(this.timer);
        window.removeEventListener('beforeunload', this.saveToLocalStorage);
        this.saveToLocalStorage();
    },
    watch: {
        storageKey() {
            this.loadFromLocalStorage();
            this.rebuildBackground();
            this.saveHistoryState();
            this.updateHasContent();
        }
    },
    methods: {
        async initCanvas() {
            await this.$nextTick();
            const rect = this.mainCanvas.getBoundingClientRect();
            const newWidth = Math.floor(rect.width * this.dpr);
            const newHeight = Math.floor(rect.height * this.dpr);
            const oldLogicalWidth = this.offCanvas.width / this.dpr;
            const oldLogicalHeight = this.offCanvas.height / this.dpr;
            const sizeChanged = (this.mainCanvas.width !== newWidth || this.mainCanvas.height !== newHeight);
            
            if (sizeChanged) {
                // 计算缩放比例
                const newLogicalWidth = newWidth / this.dpr;
                const newLogicalHeight = newHeight / this.dpr;
                let scaleX = 1, scaleY = 1;
                if (oldLogicalWidth > 0 && oldLogicalHeight > 0) {
                    scaleX = newLogicalWidth / oldLogicalWidth;
                    scaleY = newLogicalHeight / oldLogicalHeight;
                }
                
                // 缩放所有绝对坐标数据
                if (scaleX !== 1 || scaleY !== 1) {
                    this.scaleAllContent(scaleX, scaleY);
                }
                
                // 更新画布尺寸
                this.mainCanvas.width = newWidth;
                this.mainCanvas.height = newHeight || 400;
                this.offCanvas.width = newWidth;
                this.offCanvas.height = newHeight || 400;
                this.mainCtx = this.mainCanvas.getContext('2d');
                this.offCtx = this.offCanvas.getContext('2d');
                this.mainCtx.scale(this.dpr, this.dpr);
                this.offCtx.scale(this.dpr, this.dpr);
                this.mainCtx.lineCap = 'round';
                this.mainCtx.lineJoin = 'round';
                this.offCtx.lineCap = 'round';
                this.offCtx.lineJoin = 'round';
                this.applyBrushSettings();
                
                // 重建背景（基于缩放后的坐标）
                this.rebuildBackground();
                
                // 如果尺寸确实改变了，保存当前状态到历史（覆盖旧历史，避免撤销到旧尺寸）
                if (scaleX !== 1 || scaleY !== 1) {
                    this.saveHistoryState();
                }
            } else {
                // 尺寸未变，仅确保上下文设置
                this.mainCtx.setTransform(1, 0, 0, 1, 0, 0);
                this.mainCtx.scale(this.dpr, this.dpr);
                this.offCtx.setTransform(1, 0, 0, 1, 0, 0);
                this.offCtx.scale(this.dpr, this.dpr);
                this.applyBrushSettings();
                this.redrawAll();
            }
        },
        
        // 缩放所有矢量内容（自由路径、形状、文字）
        scaleAllContent(scaleX, scaleY) {
            // 缩放自由画笔路径点
            this.freeDrawPaths.forEach(path => {
                path.points.forEach(point => {
                    point.x *= scaleX;
                    point.y *= scaleY;
                });
            });
            // 缩放当前正在绘制的路径（如果有）
            if (this.currentFreePath) {
                this.currentFreePath.points.forEach(point => {
                    point.x *= scaleX;
                    point.y *= scaleY;
                });
            }
            // 缩放形状的起点和终点
            this.shapes.forEach(shape => {
                if (shape.startPoint) {
                    shape.startPoint.x *= scaleX;
                    shape.startPoint.y *= scaleY;
                }
                if (shape.endPoint) {
                    shape.endPoint.x *= scaleX;
                    shape.endPoint.y *= scaleY;
                }
            });
            // 缩放文字位置
            this.texts.forEach(text => {
                text.x *= scaleX;
                text.y *= scaleY;
            });
            // 函数图像不需要缩放，因为它是基于数学坐标的
        },
        
        // 完全根据矢量数据重绘 offCanvas（背景层）
        rebuildBackground() {
            if (!this.offCtx) return;
            const w = this.offCanvas.width / this.dpr;
            const h = this.offCanvas.height / this.dpr;
            this.offCtx.clearRect(0, 0, w, h);
            
            // 1. 绘制网格和坐标轴（如果需要）
            if (this.gridEnabled) {
                this.drawGridAndAxesOnCtx(this.offCtx, w, h);
            }
            
            // 2. 绘制所有保存的函数曲线
            this.functions.forEach(funcItem => {
                if (funcItem && typeof funcItem.func === 'function') {
                    this.drawFunctionCurveOnCtx(this.offCtx, funcItem.func, funcItem.color || '#FFB347', funcItem.lineWidth || 2.5);
                }
            });
            
            // 3. 绘制所有自由画笔笔划
            this.freeDrawPaths.forEach(path => {
                this.drawFreePathOnCtx(this.offCtx, path);
            });
            
            // 4. 刷新主画布
            this.redrawAll();
        },
        
        // 在指定上下文中绘制自由笔划
        drawFreePathOnCtx(ctx, path) {
            if (!path || !path.points || path.points.length < 2) return;
            ctx.save();
            ctx.strokeStyle = path.color;
            ctx.lineWidth = path.lineWidth;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
            ctx.beginPath();
            ctx.moveTo(path.points[0].x, path.points[0].y);
            for (let i = 1; i < path.points.length; i++) {
                const prev = path.points[i-1];
                const curr = path.points[i];
                ctx.quadraticCurveTo(prev.x, prev.y, (prev.x + curr.x)/2, (prev.y + curr.y)/2);
            }
            ctx.stroke();
            ctx.restore();
        },
        
        // 绘制网格和坐标轴（独立于 offCtx，可指定上下文）
        drawGridAndAxesOnCtx(ctx, logicalWidth, logicalHeight) {
            if (!ctx) return;
            const scaleX = logicalWidth / (this.xMax - this.xMin);
            const scaleY = logicalHeight / (this.yMax - this.yMin);
            const originX = -this.xMin * scaleX;
            const originY = this.yMax * scaleY;
            
            ctx.save();
            ctx.lineWidth = 0.8;
            ctx.strokeStyle = 'rgba(200, 200, 255, 0.5)';
            ctx.fillStyle = 'rgba(220, 240, 255, 0.8)';
            ctx.font = '12px "Microsoft YaHei"';
            ctx.shadowBlur = 0;
            
            const stepX = 1, stepY = 1;
            // 竖线
            for (let x = Math.ceil(this.xMin); x <= this.xMax; x += stepX) {
                const canvasX = originX + x * scaleX;
                if (canvasX >= 0 && canvasX <= logicalWidth) {
                    ctx.beginPath();
                    ctx.moveTo(canvasX, 0);
                    ctx.lineTo(canvasX, logicalHeight);
                    ctx.stroke();
                    if (Math.abs(x) > 1e-6) {
                        ctx.fillText(x.toFixed(0), canvasX - 6, originY + (x > 0 ? -4 : 14));
                    } else {
                        ctx.fillText('0', canvasX - 6, originY + 14);
                    }
                }
            }
            // 横线
            for (let y = Math.ceil(this.yMin); y <= this.yMax; y += stepY) {
                const canvasY = originY - y * scaleY;
                if (canvasY >= 0 && canvasY <= logicalHeight) {
                    ctx.beginPath();
                    ctx.moveTo(0, canvasY);
                    ctx.lineTo(logicalWidth, canvasY);
                    ctx.stroke();
                    if (Math.abs(y) > 1e-6) {
                        ctx.fillText(y.toFixed(0), originX + 6, canvasY - 4);
                    }
                }
            }
            // 坐标轴
            ctx.lineWidth = 1.5;
            ctx.strokeStyle = '#B0E0FF';
            ctx.beginPath();
            ctx.moveTo(0, originY);
            ctx.lineTo(logicalWidth, originY);
            ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(originX, 0);
            ctx.lineTo(originX, logicalHeight);
            ctx.stroke();
            // 箭头
            ctx.fillStyle = '#B0E0FF';
            ctx.beginPath();
            ctx.moveTo(logicalWidth - 8, originY - 4);
            ctx.lineTo(logicalWidth, originY);
            ctx.lineTo(logicalWidth - 8, originY + 4);
            ctx.fill();
            ctx.beginPath();
            ctx.moveTo(originX - 4, 8);
            ctx.lineTo(originX, 0);
            ctx.lineTo(originX + 4, 8);
            ctx.fill();
            ctx.fillStyle = '#CCFFFF';
            ctx.font = 'bold 14px "Microsoft YaHei"';
            ctx.fillText('x', logicalWidth - 12, originY - 6);
            ctx.fillText('y', originX + 8, 14);
            ctx.restore();
        },
        
        // 在指定上下文中绘制函数曲线
        drawFunctionCurveOnCtx(ctx, func, color = '#FFB347', lineWidth = 2.5) {
            if (!ctx || typeof func !== 'function') return;
            const logicalWidth = this.offCanvas.width / this.dpr;
            const logicalHeight = this.offCanvas.height / this.dpr;
            const scaleX = logicalWidth / (this.xMax - this.xMin);
            const scaleY = logicalHeight / (this.yMax - this.yMin);
            const originX = -this.xMin * scaleX;
            const originY = this.yMax * scaleY;
            const toCanvasX = (x) => originX + x * scaleX;
            const toCanvasY = (y) => originY - y * scaleY;
            
            ctx.save();
            ctx.beginPath();
            ctx.strokeStyle = color;
            ctx.lineWidth = lineWidth;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
            
            const step = (this.xMax - this.xMin) / 800;
            let isFirstPoint = true;
            let lastValid = false;
            let lastXCanvas = 0, lastYCanvas = 0;
            
            for (let x = this.xMin; x <= this.xMax; x += step) {
                let y = func(x);
                if (isNaN(y) || !isFinite(y)) {
                    isFirstPoint = true;
                    lastValid = false;
                    continue;
                }
                if (y < this.yMin - 0.5 || y > this.yMax + 0.5) {
                    isFirstPoint = true;
                    lastValid = false;
                    continue;
                }
                const canvasX = toCanvasX(x);
                const canvasY = toCanvasY(y);
                if (canvasX < 0 || canvasX > logicalWidth || canvasY < 0 || canvasY > logicalHeight) {
                    isFirstPoint = true;
                    lastValid = false;
                    continue;
                }
                if (isFirstPoint) {
                    ctx.moveTo(canvasX, canvasY);
                    isFirstPoint = false;
                } else {
                    if (lastValid && Math.hypot(canvasX - lastXCanvas, canvasY - lastYCanvas) > 50) {
                        ctx.moveTo(canvasX, canvasY);
                    } else {
                        ctx.lineTo(canvasX, canvasY);
                    }
                }
                lastXCanvas = canvasX;
                lastYCanvas = canvasY;
                lastValid = true;
            }
            ctx.stroke();
            ctx.restore();
        },
        
        // 原有方法：绘制所有形状和文字
        redrawAll() {
            if (!this.mainCtx) return;
            const w = this.mainCanvas.width / this.dpr;
            const h = this.mainCanvas.height / this.dpr;
            this.mainCtx.clearRect(0, 0, w, h);
            this.mainCtx.drawImage(this.offCanvas, 0, 0, w, h);
            this.drawAllShapes();
            this.drawAllTexts();
        },

        drawAllShapes() {
            if (!this.mainCtx) return;
            this.shapes.forEach(shape => {
                this.drawSingleShape(shape);
            });
            if (this.activeTool === 'move' && this.selectedShapeId !== null) {
                const shape = this.shapes.find(s => s.id === this.selectedShapeId);
                if (shape) {
                    this.mainCtx.save();
                    this.mainCtx.strokeStyle = '#00E5FF';
                    this.mainCtx.lineWidth = 2;
                    this.mainCtx.setLineDash([6, 8]);
                    const box = this.getShapeBoundingBox(shape);
                    if (box) {
                        this.mainCtx.strokeRect(box.x, box.y, box.w, box.h);
                    }
                    this.mainCtx.setLineDash([]);
                    this.mainCtx.restore();
                }
            }
        },

        drawSingleShape(shape) {
            if (!this.mainCtx) return;
            this.mainCtx.save();
            this.mainCtx.lineWidth = shape.lineWidth || this.size;
            this.mainCtx.strokeStyle = shape.color || this.color;
            this.mainCtx.fillStyle = shape.color || this.color;
            this.mainCtx.lineCap = 'round';
            this.mainCtx.lineJoin = 'round';
            this.mainCtx.setLineDash(shape.lineDash || []);

            const from = shape.startPoint;
            const to = shape.endPoint;
            const x = Math.min(from.x, to.x);
            const y = Math.min(from.y, to.y);
            const w = Math.abs(to.x - from.x);
            const h = Math.abs(to.y - from.y);

            switch (shape.type) {
                case 'line':
                case 'dashed':
                    this.mainCtx.beginPath();
                    this.mainCtx.moveTo(from.x, from.y);
                    this.mainCtx.lineTo(to.x, to.y);
                    this.mainCtx.stroke();
                    break;
                case 'arrow':
                    this.drawArrowOnCtx(this.mainCtx, from, to, shape.lineWidth || this.size);
                    break;
                case 'rectangle':
                    this.mainCtx.strokeRect(x, y, w, h);
                    break;
                case 'triangle': {
                    const left = x, right = x + w, bottom = y + h, top = y;
                    this.mainCtx.beginPath();
                    this.mainCtx.moveTo(left, bottom);
                    this.mainCtx.lineTo(right, bottom);
                    this.mainCtx.lineTo(left + w / 2, top);
                    this.mainCtx.closePath();
                    this.mainCtx.stroke();
                    break;
                }
                case 'parallelogram': {
                    const offset = w * 0.3;
                    const left = x, right = x + w, top = y, bottom = y + h;
                    this.mainCtx.beginPath();
                    this.mainCtx.moveTo(left + offset, top);
                    this.mainCtx.lineTo(right + offset, top);
                    this.mainCtx.lineTo(right, bottom);
                    this.mainCtx.lineTo(left, bottom);
                    this.mainCtx.closePath();
                    this.mainCtx.stroke();
                    break;
                }
                case 'circle': {
                    const cx = x + w / 2, cy = y + h / 2, r = Math.min(w, h) / 2;
                    this.mainCtx.beginPath();
                    this.mainCtx.arc(cx, cy, r, 0, Math.PI * 2);
                    this.mainCtx.stroke();
                    break;
                }
                case 'ellipse': {
                    const cx = x + w / 2, cy = y + h / 2, rx = w / 2, ry = h / 2;
                    this.mainCtx.beginPath();
                    this.mainCtx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
                    this.mainCtx.stroke();
                    break;
                }
                default: break;
            }
            this.mainCtx.restore();
        },

        getShapeBoundingBox(shape) {
            if (!shape.startPoint || !shape.endPoint) return null;
            const x = Math.min(shape.startPoint.x, shape.endPoint.x);
            const y = Math.min(shape.startPoint.y, shape.endPoint.y);
            const w = Math.abs(shape.endPoint.x - shape.startPoint.x);
            const h = Math.abs(shape.endPoint.y - shape.startPoint.y);
            return { x, y, w, h };
        },

        hitTestShape(shape, px, py) {
            const box = this.getShapeBoundingBox(shape);
            if (!box) return false;
            return (px >= box.x - 5 && px <= box.x + box.w + 5 && py >= box.y - 5 && py <= box.y + box.h + 5);
        },

        drawAllTexts() {
            if (!this.mainCtx) return;
            this.texts.forEach(text => {
                this.mainCtx.save();
                this.mainCtx.font = `${text.fontSize || 16}px "Microsoft YaHei", sans-serif`;
                this.mainCtx.fillStyle = text.color || '#FFFFFF';
                this.mainCtx.fillText(text.content, text.x, text.y);
                if (this.selectedTextId === text.id && this.activeTool === 'text') {
                    const metrics = this.mainCtx.measureText(text.content);
                    const width = metrics.width;
                    const height = text.fontSize || 16;
                    this.mainCtx.strokeStyle = '#00E5FF';
                    this.mainCtx.lineWidth = 1;
                    this.mainCtx.setLineDash([5, 5]);
                    this.mainCtx.strokeRect(text.x - 2, text.y - height + 2, width + 4, height + 4);
                    this.mainCtx.setLineDash([]);
                }
                this.mainCtx.restore();
            });
        },

        saveToLocalStorage() {
            try {
                const state = {
                    texts: this.texts,
                    shapes: this.shapes,
                    freeDrawPaths: this.freeDrawPaths,
                    functions: this.functions.map(f => ({   // 只保存可序列化字段
                        command: f.command,
                        color: f.color,
                        lineWidth: f.lineWidth
                    })),
                    color: this.color,
                    size: this.size,
                    brushType: this.brushType,
                    xMin: this.xMin,
                    xMax: this.xMax,
                    yMin: this.yMin,
                    yMax: this.yMax,
                    gridEnabled: this.gridEnabled
                };
                localStorage.setItem(this.storageKey, JSON.stringify(state));
            } catch(e) { console.warn(e); }
        },
        loadFromLocalStorage() {
            const saved = localStorage.getItem(this.storageKey);
            if (!saved) return;
            try {
                const state = JSON.parse(saved);
                this.texts = state.texts || [];
                this.shapes = state.shapes || [];
                this.freeDrawPaths = state.freeDrawPaths || [];
                
                // 兼容旧版本单函数存储
                if (state.functions) {
                    this.functions = state.functions.map(f => ({
                        command: f.command,
                        color: f.color || '#FFB347',
                        lineWidth: f.lineWidth || 2.5,
                        func: this.getFunctionByCommand(f.command)
                    }));
                } else if (state.currentFunction) {
                    // 旧数据转换
                    this.functions = [{
                        command: state.currentFunction.command,
                        color: state.currentFunction.color || '#FFB347',
                        lineWidth: state.currentFunction.lineWidth || 2.5,
                        func: this.getFunctionByCommand(state.currentFunction.command)
                    }];
                } else {
                    this.functions = [];
                }
                
                this.color = state.color || '#FF0000';
                this.size = state.size || 1;
                this.brushType = state.brushType || 'free';
                this.xMin = state.xMin !== undefined ? state.xMin : -6;
                this.xMax = state.xMax !== undefined ? state.xMax : 6;
                this.yMin = state.yMin !== undefined ? state.yMin : -5;
                this.yMax = state.yMax !== undefined ? state.yMax : 5;
                this.gridEnabled = state.gridEnabled !== undefined ? state.gridEnabled : true;
                this.applyBrushSettings();
                this.rebuildBackground();
                this.updateHasContent();
            } catch(e) { console.warn(e); }
        },

        // 辅助：根据命令获取函数
        getFunctionByCommand(command) {
            const functions = {
                linear: (x) => 2 * x + 1,
                quadratic: (x) => x * x - 2,
                cubic: (x) => Math.pow(x, 3) / 3 - x,
                reciprocal: (x) => (Math.abs(x) < 1e-6 ? NaN : 3 / x),
                exp: (x) => Math.pow(2, x),
                log: (x) => (x + 1 > 0 ? Math.log(x + 1) : NaN),
                hook: (x) => (Math.abs(x) < 1e-6 ? NaN : x + 1 / x),
                sin: (x) => Math.sin(x),
                cos: (x) => Math.cos(x),
                tan: (x) => {
                    const val = Math.tan(x);
                    return Math.abs(val) > 10 ? NaN : val;
                },
                sinc: (x) => (Math.abs(x) < 1e-6 ? 1 : Math.sin(x) / x),
                lnxdivx: (x) => (x > 0 ? Math.log(x) / x : NaN),
                xsinx: (x) => x * Math.sin(x),
                expdivx: (x) => (Math.abs(x) < 1e-6 ? NaN : Math.exp(x) / x),
            };
            return functions[command] || null;
        },

        saveHistoryState() {
            const state = {
                texts: JSON.parse(JSON.stringify(this.texts)),
                shapes: JSON.parse(JSON.stringify(this.shapes)),
                freeDrawPaths: JSON.parse(JSON.stringify(this.freeDrawPaths)),
                functions: this.functions.map(f => ({
                    command: f.command,
                    color: f.color,
                    lineWidth: f.lineWidth
                })),
                color: this.color,
                size: this.size,
                brushType: this.brushType,
                xMin: this.xMin,
                xMax: this.xMax,
                yMin: this.yMin,
                yMax: this.yMax,
                gridEnabled: this.gridEnabled
            };
            if (this.step < this.history.length - 1) {
                this.history = this.history.slice(0, this.step + 1);
            }
            this.history.push(state);
            this.step = this.history.length - 1;
            this.updateUndoRedoState();
            this.updateHasContent();
            this.saveToLocalStorage();
        },
        updateUndoRedoState() {
            this.isUndoAble = this.step > 0;
            this.isRedoAble = this.step < this.history.length - 1;
        },
        restoreHistoryState(index) {
            if (index < 0 || index >= this.history.length) return;
            const state = this.history[index];
            if (!state) return;
            this.texts = JSON.parse(JSON.stringify(state.texts));
            this.shapes = JSON.parse(JSON.stringify(state.shapes));
            this.freeDrawPaths = JSON.parse(JSON.stringify(state.freeDrawPaths));
            if (state.functions) {
                this.functions = state.functions.map(f => ({
                    command: f.command,
                    color: f.color,
                    lineWidth: f.lineWidth,
                    func: this.getFunctionByCommand(f.command)
                }));
            } else {
                this.functions = [];
            }
            this.color = state.color;
            this.size = state.size;
            this.brushType = state.brushType;
            this.xMin = state.xMin;
            this.xMax = state.xMax;
            this.yMin = state.yMin;
            this.yMax = state.yMax;
            this.gridEnabled = state.gridEnabled;
            this.applyBrushSettings();
            this.selectedShapeId = null;
            this.selectedTextId = null;
            this.rebuildBackground();
            this.step = index;
            this.updateUndoRedoState();
        },
        canvasUndo() {
            if (this.step > 0) this.restoreHistoryState(this.step - 1);
            else this.$message.warning('不能再继续撤销了');
        },
        canvasRedo() {
            if (this.step < this.history.length - 1) this.restoreHistoryState(this.step + 1);
            else this.$message.warning('已经是最新的记录了');
        },
        canvasClear() {
            if (!this.hasContent) {
                this.$message.warning('画板已经是空白，无需清除');
                return;
            }
            this.freeDrawPaths = [];
            this.functions = [];          // 清空所有函数图像
            this.texts = [];
            this.shapes = [];
            this.selectedShapeId = null;
            this.selectedTextId = null;
            this.rebuildBackground();
            this.saveHistoryState();
            this.updateHasContent();
        },

        // 自由画笔的绘制方法（实时绘制 + 记录路径）
        startDrawing(e) {
            if (this.activeTool !== 'draw') return;
            const pos = this.getCanvasCoords(e);
            this.isDrawing = true;
            this.startPoint = pos;
            if (this.brushType === 'free') {
                this.currentFreePath = {
                    points: [{ x: pos.x, y: pos.y }],
                    color: this.color,
                    lineWidth: this.size
                };
                this.offCtx.beginPath();
                this.offCtx.moveTo(pos.x, pos.y);
                this.lastPos = pos;
            }
        },
        drawMove(e) {
            if (!this.isDrawing || this.activeTool !== 'draw') return;
            const pos = this.getCanvasCoords(e);
            if (this.brushType === 'free') {
                if (!this.lastPos) {
                    this.lastPos = pos;
                    return;
                }
                this.offCtx.quadraticCurveTo(this.lastPos.x, this.lastPos.y,
                    (pos.x + this.lastPos.x) / 2, (pos.y + this.lastPos.y) / 2);
                this.offCtx.stroke();
                this.lastPos = pos;
                if (this.currentFreePath) {
                    this.currentFreePath.points.push({ x: pos.x, y: pos.y });
                }
                this.redrawAll();
            }
        },
        stopDrawing(e) {
            if (!this.isDrawing || this.activeTool !== 'draw') {
                this.isDrawing = false;
                return;
            }
            const endPoint = this.getCanvasCoords(e);
            
            if (this.brushType !== 'free' && this.startPoint) {
                this.createShape(this.startPoint, endPoint);
            } 
            else if (this.brushType === 'free' && this.currentFreePath && this.currentFreePath.points.length > 1) {
                this.freeDrawPaths.push({ ...this.currentFreePath });
                this.currentFreePath = null;
                this.saveHistoryState();
            }
            
            this.isDrawing = false;
            this.lastPos = null;
            this.startPoint = null;
            this.redrawAll();
        },
        
        createShape(from, to) {
            let lineDash = [];
            if (this.brushType === 'dashed') {
                lineDash = [5, 8];
            }
            const shape = {
                id: Date.now(),
                type: this.brushType,
                startPoint: { x: from.x, y: from.y },
                endPoint: { x: to.x, y: to.y },
                color: this.color,
                lineWidth: this.size,
                lineDash: lineDash
            };
            this.shapes.push(shape);
            this.saveHistoryState();
            this.redrawAll();
        },

        drawArrowOnCtx(ctx, from, to, lineWidth = this.size) {
            const arrowSize = Math.max(12, lineWidth * 2);
            const angle = Math.atan2(to.y - from.y, to.x - from.x);
            const arrowX = to.x;
            const arrowY = to.y;
            const angle1 = angle - Math.PI / 6;
            const angle2 = angle + Math.PI / 6;
            const wing1 = { x: arrowX - arrowSize * Math.cos(angle1), y: arrowY - arrowSize * Math.sin(angle1) };
            const wing2 = { x: arrowX - arrowSize * Math.cos(angle2), y: arrowY - arrowSize * Math.sin(angle2) };
            
            ctx.beginPath();
            ctx.moveTo(from.x, from.y);
            ctx.lineTo(to.x, to.y);
            ctx.stroke();
            
            ctx.beginPath();
            ctx.moveTo(to.x, to.y);
            ctx.lineTo(wing1.x, wing1.y);
            ctx.lineTo(wing2.x, wing2.y);
            ctx.fill();
        },

        activateMoveTool() {
            this.activeTool = 'move';
            this.selectedTextId = null;
            this.draggingTextId = null;
            this.draggingShapeId = null;
            this.redrawAll();
            this.$message.info('移动模式：点击选择形状，拖拽移动');
        },
        activateDrawTool() {
            this.activeTool = 'draw';
            this.selectedTextId = null;
            this.selectedShapeId = null;
            this.draggingTextId = null;
            this.draggingShapeId = null;
            this.redrawAll();
        },
        activateTextTool() {
            this.activeTool = 'text';
            this.selectedShapeId = null;
            this.selectedTextId = null;
            this.draggingTextId = null;
            this.draggingShapeId = null;
            this.redrawAll();
            this.$message.info('文字模式：点击画布添加文字，双击文字编辑，拖拽移动');
        },

        findTextAt(x, y) {
            for (let i = this.texts.length - 1; i >= 0; i--) {
                const t = this.texts[i];
                this.mainCtx.save();
                this.mainCtx.font = `${t.fontSize || 16}px "Microsoft YaHei", sans-serif`;
                const metrics = this.mainCtx.measureText(t.content);
                const width = metrics.width;
                const height = t.fontSize || 16;
                this.mainCtx.restore();
                if (x >= t.x - 5 && x <= t.x + width + 5 && y >= t.y - height && y <= t.y + 5) {
                    return t;
                }
            }
            return null;
        },

        onCanvasDoubleClick(e) {
            if (this.activeTool !== 'text') return;
            const pos = this.getCanvasCoords(e);
            const hit = this.findTextAt(pos.x, pos.y);
            if (hit) {
                this.editingTextId = hit.id;
                this.textInputContent = hit.content;
                this.textDialogTitle = '编辑文字';
                this.textDialogVisible = true;
            }
        },

        onCanvasMouseDown(e) {
            const pos = this.getCanvasCoords(e);
            if (this.activeTool === 'text') {
                const hit = this.findTextAt(pos.x, pos.y);
                if (hit) {
                    this.selectedTextId = hit.id;
                    this.draggingTextId = hit.id;
                    this.dragStartX = pos.x - hit.x;
                    this.dragStartY = pos.y - hit.y;
                    this.redrawAll();
                    e.preventDefault();
                } else {
                    this.pendingTextPosition = pos;
                    this.textInputContent = '';
                    this.textDialogTitle = '添加文字';
                    this.textDialogVisible = true;
                }
                return;
            }
            if (this.activeTool === 'move') {
                let hitShape = null;
                for (let i = this.shapes.length - 1; i >= 0; i--) {
                    if (this.hitTestShape(this.shapes[i], pos.x, pos.y)) {
                        hitShape = this.shapes[i];
                        break;
                    }
                }
                if (hitShape) {
                    this.selectedShapeId = hitShape.id;
                    this.draggingShapeId = hitShape.id;
                    this.dragShapeOffsetX = pos.x - hitShape.startPoint.x;
                    this.dragShapeOffsetY = pos.y - hitShape.startPoint.y;
                    this.redrawAll();
                    e.preventDefault();
                } else {
                    this.selectedShapeId = null;
                    this.redrawAll();
                }
                return;
            }
            this.startDrawing(e);
        },

        onCanvasMouseMove(e) {
            const pos = this.getCanvasCoords(e);
            if (this.activeTool === 'text') {
                if (this.draggingTextId !== null) {
                    const textObj = this.texts.find(t => t.id === this.draggingTextId);
                    if (textObj) {
                        textObj.x = pos.x - this.dragStartX;
                        textObj.y = pos.y - this.dragStartY;
                        this.redrawAll();
                    }
                }
                return;
            }
            if (this.activeTool === 'move') {
                if (this.draggingShapeId !== null) {
                    const shape = this.shapes.find(s => s.id === this.draggingShapeId);
                    if (shape) {
                        const newStartX = pos.x - this.dragShapeOffsetX;
                        const newStartY = pos.y - this.dragShapeOffsetY;
                        const dx = newStartX - shape.startPoint.x;
                        const dy = newStartY - shape.startPoint.y;
                        shape.startPoint.x += dx;
                        shape.startPoint.y += dy;
                        shape.endPoint.x += dx;
                        shape.endPoint.y += dy;
                        this.redrawAll();
                    }
                }
                return;
            }
            this.drawMove(e);
        },

        onCanvasMouseUp(e) {
            if (this.activeTool === 'text') {
                if (this.draggingTextId !== null) {
                    this.draggingTextId = null;
                    this.saveHistoryState();
                    this.redrawAll();
                }
                return;
            }
            if (this.activeTool === 'move') {
                if (this.draggingShapeId !== null) {
                    this.draggingShapeId = null;
                    this.selectedShapeId = null;
                    this.saveHistoryState();
                    this.redrawAll();
                }
                return;
            }
            this.stopDrawing(e);
        },

        onCanvasMouseLeave(e) {
            if (this.activeTool === 'text') {
                this.draggingTextId = null;
                return;
            }
            if (this.activeTool === 'move') {
                if (this.draggingShapeId !== null) {
                    this.draggingShapeId = null;
                    this.selectedShapeId = null;
                    this.saveHistoryState();
                    this.redrawAll();
                }
                return;
            }
            if (this.isDrawing) this.stopDrawing(e);
        },

        onCanvasTouchStart(e) {
            if (e.touches.length) {
                const fakeEvent = { clientX: e.touches[0].clientX, clientY: e.touches[0].clientY };
                this.onCanvasMouseDown(fakeEvent);
            }
        },
        onCanvasTouchMove(e) {
            if (e.touches.length) {
                const fakeEvent = { clientX: e.touches[0].clientX, clientY: e.touches[0].clientY };
                this.onCanvasMouseMove(fakeEvent);
            }
        },
        onCanvasTouchEnd(e) {
            if (e.changedTouches && e.changedTouches.length > 0) {
                const touch = e.changedTouches[0];
                const fakeEvent = { clientX: touch.clientX, clientY: touch.clientY };
                this.onCanvasMouseUp(fakeEvent);
            } else {
                const fakeEvent = { clientX: 0, clientY: 0 };
                this.onCanvasMouseUp(fakeEvent);
            }
        },

        saveTextContent() {
            if (!this.textInputContent.trim()) {
                this.$message.warning('文字内容不能为空');
                return;
            }
            if (this.editingTextId !== null) {
                const idx = this.texts.findIndex(t => t.id === this.editingTextId);
                if (idx !== -1) {
                    this.texts[idx].content = this.textInputContent;
                    this.saveHistoryState();
                    this.redrawAll();
                }
                this.editingTextId = null;
            } else if (this.pendingTextPosition) {
                const newText = {
                    id: Date.now(),
                    x: this.pendingTextPosition.x,
                    y: this.pendingTextPosition.y,
                    content: this.textInputContent,
                    fontSize: 16,
                    color: this.color,
                };
                this.texts.push(newText);
                this.selectedTextId = newText.id;
                this.saveHistoryState();
                this.redrawAll();
                this.pendingTextPosition = null;
            }
            this.textDialogVisible = false;
            this.textInputContent = '';
        },

        drawFunctionByCommand(command) {
            const func = this.getFunctionByCommand(command);
            if (!func) return;
            // 添加新函数到数组（支持多曲线）
            this.functions.push({
                command: command,
                func: func,
                color: this.color,
                lineWidth: 2.5
            });
            this.rebuildBackground();
            this.saveHistoryState();
        },

        getCanvasCoords(event) {
            const rect = this.mainCanvas.getBoundingClientRect();
            let clientX, clientY;
            if (event.touches) {
                clientX = event.touches[0].clientX;
                clientY = event.touches[0].clientY;
            } else {
                clientX = event.clientX;
                clientY = event.clientY;
            }
            let x = (clientX - rect.left) * (this.mainCanvas.width / rect.width / this.dpr);
            let y = (clientY - rect.top) * (this.mainCanvas.height / rect.height / this.dpr);
            x = Math.min(Math.max(0, x), this.mainCanvas.width / this.dpr);
            y = Math.min(Math.max(0, y), this.mainCanvas.height / this.dpr);
            return { x, y };
        },
        handleSizeChange(e) {
            this.size = parseInt(e.target.value);
            this.applyBrushSettings();
        },
        handleSizeInput(e) {
            this.size = parseInt(e.target.value);
            this.applyBrushSettings();
        },
        applyBrushSettings() {
            [this.mainCtx, this.offCtx].forEach(ctx => {
                if (ctx) {
                    ctx.strokeStyle = this.color;
                    ctx.fillStyle = this.color;
                    ctx.lineWidth = this.size;
                }
            });
        },
        triggerColorPicker() {
            this.$refs.colorInput.click();
        },
        onColorChange(event) {
            const newColor = event.target.value;
            this.color = newColor;
            this.applyBrushSettings();
        },
        exitFullscreen() {
            this.$emit('update:fullscreen', false);
        },
        handleFull() {
            this.$emit('update:fullscreen', true);
        },
        
        updateHasContent() {
            if (this.texts.length > 0 || this.shapes.length > 0 || this.freeDrawPaths.length > 0 || this.functions.length > 0) {
                this.hasContent = true;
                return;
            }
            this.hasContent = false;
        },
        
        onCanvasResize() {
            const rect = this.mainCanvas.getBoundingClientRect();
            if (rect.width === 0 || rect.height === 0) return;
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(async () => {
                await this.initCanvas();
                this.saveToLocalStorage();
            }, 100);
        }
    },
};
</script>

<style scoped lang="scss">
.draw-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: transparent !important;
    position: relative;
}
.close-fullscreen-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    color: #00E5FF;
    cursor: pointer;
    z-index: 101;
    background: rgba(0,0,0,0.5);
    border-radius: 50%;
    padding: 4px;
    transition: all 0.2s;
    &:hover {
        color: #80FFFF;
        background: rgba(0,0,0,0.7);
    }
}
canvas {
    cursor: crosshair;
    width: 100% !important;
    flex: 1;
    min-height: 0;
    background: transparent !important;
    box-shadow: 0 0 0 1px rgba(0,229,255,0.6);
    touch-action: none;
}

.operate-group {
    height: 40px;
    display: flex;
    align-items: center;
    background: transparent;
    flex-shrink: 0;
    gap: 6px;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    
    &::-webkit-scrollbar {
        height: 4px;
    }
    &::-webkit-scrollbar-track {
        background: rgba(0, 229, 255, 0.2);
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: #00E5FF;
        border-radius: 4px;
    }
    
    > * {
        flex-shrink: 0;
    }
    
    .item {
        height: 100%;
        padding: 5px 8px;
        color:rgb(4, 204, 223);
        border-right: 1.5px solid rgba(0,229,255,0.7);
        display: inline-flex;
        align-items: center;
    }
    .tool-active {
        background: rgba(0,229,255,0.2);
        border-radius: 4px;
    }
    .active-tool-text {
        color:rgb(226, 170, 1) !important;
    }
    .function-btn {
        color:rgb(4, 204, 223);
        border-right: 1.5px solid rgba(0,229,255,0.7);
        border-radius: 0;
        height: 100%;
        padding: 0 12px;
        i {
            margin-right: 4px;
        }
        &:hover {
            background: rgba(0,229,255,0.15);
            color:rgb(3, 212, 212);
        }
    }
    .undo, .redo {
        opacity: 0.5;
    }
    .isUndoAble, .isRedoAble {
        opacity: 1;
        fill: #00E5FF;
    }
}

.color-picker-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    
    .color-picker-svg {
        width: 50px;
        height: 46px;
        color: #00E5FF;
    }
    
    .hidden-color-input {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
        pointer-events: none;
    }
    
    &:hover {
        opacity: 0.8;
    }
}

.brush-select-active {
    ::v-deep .el-input__inner {
        color:rgb(231, 174, 2) !important;
        background-color: transparent !important;
        border-color: rgba(0, 229, 255, 0.7);
    }
}

::v-deep .el-select {
    .el-input__inner {
        background-color: transparent !important;
        color: #999999;
        border-color: rgba(0, 229, 255, 0.5);
        
        &:focus {
            border-color: #00E5FF;
        }
        
        &::placeholder {
            color: rgba(153, 153, 153, 0.7);
        }
    }
    
    &.is-disabled .el-input__inner {
        background-color: transparent !important;
        color: #666666;
        border-color: rgba(0, 229, 255, 0.3);
    }
}

.brush-select-popper {
    background-color: #1a2a2f;
    border-color: #00E5FF;
    
    .el-select-dropdown__item {
        color:rgb(85, 88, 88);
        
        &:hover {
            background-color: rgba(0, 229, 255, 0.07);
            color:rgb(247, 199, 55);
        }
        
        &.selected {
            color:rgb(247, 199, 55);
            font-weight: 500;
        }
    }
}

.thickness-control {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(0, 0, 0, 0.4);
    padding: 4px 12px;
    border-radius: 18px;
    margin-left: 4px;
    flex-shrink: 0;
    
    .thickness-label {
        color: #00E5FF;
        font-size: 12px;
    }
    
    .thickness-slider {
        width: 120px;
        -webkit-appearance: none;
        background: rgba(0, 229, 255, 0.4);
        border-radius: 10px;
        height: 6px;
        
        &::-webkit-slider-thumb {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #B3FFFF;
            cursor: pointer;
            -webkit-appearance: none;
            box-shadow: 0 0 4px rgba(0,0,0,0.3);
        }
        
        &::-webkit-slider-thumb:active {
            transform: scale(1.2);
        }
    }
    
    .thickness-value {
        min-width: 24px;
        text-align: center;
        color: #FFD966;
        font-weight: bold;
        font-size: 14px;
    }
}

@media (max-width: 768px) {
    .operate-group {
        gap: 4px;
        padding-bottom: 4px;
    }
    .thickness-control {
        .thickness-slider {
            width: 100px;
        }
    }
}
</style>

<style lang="scss">
.draw-dialog {
  .el-dialog {
    background: rgba(15, 26, 31, 0.92);
    backdrop-filter: blur(12px);
    border-radius: 28px;
    overflow: hidden;
    box-shadow: 0 20px 35px -12px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 229, 255, 0.25);
    transition: all 0.25s ease;
  }

  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 229, 255, 0.2);
    padding: 18px 24px;
    background: transparent;
    border-radius: 0;
        
    .el-dialog__title {
    color: #ffffff !important;        // 纯白色，提高对比度
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-shadow: 0 0 6px rgba(0, 229, 255, 0.6); // 青色光晕，增强辨识
    }
    
    .el-dialog__headerbtn {
      top: 20px;
      right: 22px;
      
      .el-dialog__close {
        color: #00E5FF;
        font-size: 20px;
        transition: all 0.2s;
        
        &:hover {
          color: #80FFFF;
          transform: scale(1.15);
        }
      }
    }
  }
  
  .el-dialog__body {
    padding: 28px 24px 24px;
    
    .el-input__inner {
      background: rgba(7, 16, 19, 0.8);
      border: 1px solid rgba(0, 229, 255, 0.6);
      border-radius: 16px;
      color: #E0F2FE;
      font-size: 15px;
      padding: 12px 16px;
      height: auto;
      transition: all 0.2s;
      
      &:focus {
        border-color: #80FFFF;
        box-shadow: 0 0 0 3px rgba(0, 229, 255, 0.2);
        outline: none;
      }
      
      &::placeholder {
        color: rgba(0, 229, 255, 0.5);
      }
    }
    
    .el-input__count {
      background: transparent;
      color: rgba(0, 229, 255, 0.7);
      font-size: 12px;
      bottom: -22px;
    }
  }
  
  .el-dialog__footer {
    padding: 16px 24px 24px;
    border-top: 1px solid rgba(0, 229, 255, 0.15);
    
    .el-button {
      border-radius: 40px;
      padding: 8px 24px;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.2s;
      
      &:not(.el-button--primary) {
        background: transparent;
        border: 1px solid #00E5FF;
        color: #00E5FF;
        
        &:hover {
          background: rgba(0, 229, 255, 0.15);
          border-color: #80FFFF;
          color: #80FFFF;
          transform: translateY(-1px);
        }
      }
      
      &.el-button--primary {
        background: linear-gradient(135deg, #0088AA 0%, #00B4CC 100%);
        border: none;
        color: #FFFFFF;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        
        &:hover {
          background: linear-gradient(135deg, #00AACC 0%, #00D4EE 100%);
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(0, 229, 255, 0.35);
        }
        
        &:active {
          transform: translateY(1px);
        }
      }
    }
  }
  
  @media (max-width: 768px) {
    .el-dialog {
      width: 90% !important;
      border-radius: 24px;
    }
    
    .el-dialog__header {
      padding: 14px 20px;
      
      .el-dialog__title {
        font-size: 16px;
      }
    }
    
    .el-dialog__body {
      padding: 20px 16px;
    }
    
    .el-dialog__footer {
      padding: 12px 20px 20px;
      
      .el-button {
        padding: 6px 20px;
      }
    }
  }
}
</style>
